import { useInjection } from 'inversify-react';

import { Page, useProjects } from '@desygner/ui-features-projects';

import { TYPES } from '../../../../inversify.types';
import { IViewerStoreInjector } from '../../../../store';
import { DynamicSizeSkeleton } from '../../../components/Skeleton/DynamicSizeSkeleton';
import { useLoadPageContent } from '../../../hooks/useLoadPageContent';
import { StyledPageItemWrapper } from '../Viewer.styles';
import { AnimatedSVGContainer } from './AnimatedSVGContainer';

export type SinglePageModeProps = {
  page: Page;
  index: number;
};

export const SinglePageMode = ({ page, index }: SinglePageModeProps) => {
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const { pages, project } = useProjects();

  const zoomLevel = useViewerStore((state) => state.zoom / 100);

  const pageData = pages[page.id] as Page | undefined;
  const projectData = project?.pages[index];

  const selectedPageNumber = useViewerStore((state) => state.selectedPageNumber);

  const { isProcessingPageContent } = useLoadPageContent({
    pageId: page.id,
    page,
  });

  const isNotCurrentPageNumber = index + 1 !== selectedPageNumber;

  if (isNotCurrentPageNumber || !projectData?.width || !projectData?.height) {
    return null;
  }

  const shouldShowSkeleton = isProcessingPageContent || !pageData?.content;

  const computedWidth = (pageData?.width || projectData?.width || 0) * zoomLevel;
  const computedHeight = (pageData?.height || projectData?.height || 0) * zoomLevel;

  return (
    <StyledPageItemWrapper
      data-page-number={page.page_number || index + 1}
      style={{
        width: `${computedWidth}px`,
        height: `${computedHeight}px`,
      }}
    >
      {shouldShowSkeleton ? (
        <DynamicSizeSkeleton width={computedWidth} height={computedHeight} />
      ) : (
        <div
          style={{
            width: `${computedWidth}px`,
            height: `${computedHeight}px`,
          }}
        >
          <AnimatedSVGContainer id={page.id} content={pageData.content} />
        </div>
      )}
    </StyledPageItemWrapper>
  );
};
